import { createSlice } from '../wrappers';

export interface IFormError {
	source: string;
	text: string;
}

const initialState = {
	email: '',
	login: '',
	nickname: '',
	password: '',
	passwordRep: '',
	loading: false,
	passwordVisible: false,
	resetToken: '',
};

const formDataSlice = createSlice({
	name: 'formData',
	initialState,
	reducers: {
		setEmail: (state, action) => {
			state.email = action.payload;
		},
		setLogin: (state, action) => {
			state.login = action.payload;
		},
		setNickname: (state, action) => {
			state.nickname = action.payload;
		},
		setPassword: (state, action) => {
			state.password = action.payload;
		},
		setPasswordRep: (state, action) => {
			state.passwordRep = action.payload;
		},
		setLoading: (state, action) => {
			state.loading = action.payload;
		},
		setPasswordVisible: (state, action) => {
			state.passwordVisible = action.payload;
		},
		setResetToken: (state, action) => {
			state.resetToken = action.payload;
		},
	},
});

export const {
	setEmail,
	setNickname,
	setPassword,
	setPasswordRep,
	setLoading,
	setPasswordVisible,
	setLogin,
	setResetToken,
} = formDataSlice.actions;

export default formDataSlice.reducer;
